export const DEAL_CHECKER_CREATIVE_ID = 'edm-lease-deals-deal-checker';
